import { visserApi } from "./visserApi";
const getAllCalculationsByWorkOrderID = (workOrderId) => {
    return visserApi.get(`calculation/GetAllArticlesByWorkOrderID/${workOrderId}`);
};
const createCalculation = (materialDto) => {
    return visserApi.post('calculation/Create', materialDto);
};
const updateCalculation = (Id, materialDto) => {
    return visserApi.put(`calculation/Update/${Id}`, materialDto);
};
const getCalculationByID = (Id) => {
    return visserApi.get(`calculation/GetCalculationAndArticlesByID/${Id}`);
};
const deleteCalculationById = (Id) => {
    return visserApi.delete(`calculation/Delete/${Id}`);
};
const updateCalculationPosition = async (updateCalculationAmountPosition) => {
    return await visserApi.put(`calculation/UpdateCalculationPosition`, updateCalculationAmountPosition);
};
const updateBulkCalculation = async (updateBulkCalculation) => {
    return await visserApi.put(`calculation/UpdateBulkCalculation`, updateBulkCalculation);
};
const CalculationApi = {
    getAllCalculationsByWorkOrderID,
    createCalculation,
    updateCalculation,
    getCalculationByID,
    deleteCalculationById,
    updateCalculationPosition,
    updateBulkCalculation
};
export default CalculationApi;
